import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const HtmlViewer = styled.div`
  p,
  ul,
  ol {
    margin-bottom: 1em;
  }
  & ul {
    list-style-position: outside;
    margin-left: 1.3em;
  }
  & ol {
    list-style-position: outside;
    margin-left: 1.3em;
  }
`;

function StyledHtmlViewer({ children, ...rest }) {
  return <HtmlViewer {...rest}>{children}</HtmlViewer>;
}

StyledHtmlViewer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StyledHtmlViewer;
